import { Injectable } from "@angular/core";
import { MyOffersAppCommand } from "@fabric-types/app-offers";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { CORE_DEPOSIT_ACTION_TYPE } from "@obg/core.payment";
import { CAMPAIGN_ACTION_TYPE } from "@obg/ngx.common";
import { DocumentRef } from "@obg/ngx.global.evo";
import { delay, tap } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class MyOffersLobbyEffects {
	refreshOffers$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(
					CORE_DEPOSIT_ACTION_TYPE.completed,
					CAMPAIGN_ACTION_TYPE.optInSuccess,
					CAMPAIGN_ACTION_TYPE.joinByCodeSuccess
				),
				delay(1000),
				tap(() => {
					this.documentRef.obgEventBus?.dispatch(MyOffersAppCommand.RefreshOffers);
				})
			),
		{ dispatch: false }
	);

	constructor(
		private actions$: Actions,
		private documentRef: DocumentRef
	) {}
}
